module.exports = __webpack_public_path__ + "img/HUAZHU_NEW.e37b4961.png";